import { render, staticRenderFns } from "./CanceledSettings.vue?vue&type=template&id=230cacb8&scoped=true"
import script from "./CanceledSettings.vue?vue&type=script&lang=js"
export * from "./CanceledSettings.vue?vue&type=script&lang=js"
import style0 from "./CanceledSettings.vue?vue&type=style&index=0&id=230cacb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230cacb8",
  null
  
)

export default component.exports